<template>

  <router-view v-slot="{ Component }">
    <transition name="routeFade" mode="out-in" >
      <component :is="Component" />
    </transition>
  </router-view>

</template>

<style lang="scss">

@font-face { font-family: "Roboto Condensed"; src: url("https://fonts.gstatic.com/s/robotocondensed/v19/ieVl2ZhZI2eCN5jzbjEETS9weq8-19K7DQ.woff2") format("woff2"); font-style: normal; font-weight: 400; unicode-range: U+0-FF, U+131, U+152-153, U+2BB-2BC, U+2C6, U+2DA, U+2DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD; }

#app {
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 18px;
  line-height: 1.5;
  letter-spacing: 0px;
  font-style: normal;
  text-align: center;
  color: #2c3e50;
}

a {
  color: #757474;
}

a:hover, a.router-link-exact-active:hover{
  font-weight: 800;
}

a.router-link-exact-active{
  color: #2c3e50;
  
}

body{
  margin: 0px;
}

h1 { 
  font-weight: 400;
  color: #111111;
  font-size: 44px;
  line-height: 1;
  margin-top: 0px;
  margin-bottom: 0px;
}

h2 {

}

h3 {
  font-weight: 300;
  color: #111111;
  line-height: 1;
  margin-top:0px;
  margin-bottom: 0px;
  font-size: 30px;
}

</style>

<style scoped>
.routeFade-enter-active, .routeFade-leave-active {
  transition: opacity .5s ease;
}

.routeFade-leave-from {
  opacity: 1;
}

.routeFade-enter-from, .routeFade-leave-to, .routeFade-leave-active {
  opacity: 0;
}
</style>